'use client';

import { useContext } from 'react';
import { ProductSearchBoxContext } from '../contexts';

export const useProductSearchBox = () => {
  return useContext(ProductSearchBoxContext);
};
